var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"floating-holder"}},[(_vm.whatsapp)?_c('div',{staticClass:"float-holder highlightOnHover",class:{ 'clicked': _vm.clickedWahts },on:{"click":_vm.openWhatsApp}},[_c('span',{staticClass:"imoon-whatsapp"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }